import { render, staticRenderFns } from "./Authen.vue?vue&type=template&id=5f3130d1&scoped=true"
import script from "./Authen.vue?vue&type=script&lang=js"
export * from "./Authen.vue?vue&type=script&lang=js"
import style0 from "./Authen.vue?vue&type=style&index=0&id=5f3130d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3130d1",
  null
  
)

export default component.exports